'use client';

/*
 * Documentation:
 * Toggle Group — https://app.subframe.com/6fc7f5fbb098/library?component=Toggle+Group_2026f10a-e3cc-4c89-80da-a7259acae3b7
 */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FeatherStar } from '@subframe/core';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
interface ItemProps extends React.ComponentProps<typeof SubframeCore.ToggleGroup.Item> {
  disabled?: boolean;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}
const Item = React.forwardRef<HTMLDivElement, ItemProps>(function Item({
  disabled = false,
  children,
  icon = <FeatherStar />,
  className,
  ...otherProps
}: ItemProps, ref) {
  return <SubframeCore.ToggleGroup.Item asChild={true} {...otherProps}>
      <div className={SubframeUtils.twClassNames('group/56dea6ed aria-[checked=true]:bg-default-background hover:aria-[checked=true]:bg-default-background active:aria-[checked=true]:bg-default-background flex h-7 w-full cursor-pointer items-center justify-center gap-2 rounded-md px-2 py-1 active:bg-neutral-100 aria-[checked=true]:shadow-sm', {
      'hover:bg-transparent active:bg-transparent': disabled
    }, className)} ref={ref}>
        {icon ? <SubframeCore.IconWrapper className={SubframeUtils.twClassNames('text-body font-body text-subtext-color group-hover/56dea6ed:text-default-font group-active/56dea6ed:text-default-font group-aria-[checked=true]/56dea6ed:text-default-font', {
        'text-neutral-400 group-hover/56dea6ed:text-neutral-400 group-active/56dea6ed:text-neutral-400': disabled
      })}>
            {icon}
          </SubframeCore.IconWrapper> : null}
        {children ? <span className={SubframeUtils.twClassNames('text-caption-bold font-caption-bold text-subtext-color group-hover/56dea6ed:text-default-font group-active/56dea6ed:text-default-font group-aria-[checked=true]/56dea6ed:text-default-font whitespace-nowrap', {
        'text-neutral-400 group-hover/56dea6ed:text-neutral-400 group-active/56dea6ed:text-neutral-400': disabled
      })}>
            {children}
          </span> : null}
      </div>
    </SubframeCore.ToggleGroup.Item>;
});
interface ToggleGroupRootProps extends React.ComponentProps<typeof SubframeCore.ToggleGroup.Root> {
  children?: React.ReactNode;
  value?: string;
  onValueChange?: (value: string) => void;
  className?: string;
}
const ToggleGroupRoot = React.forwardRef<HTMLDivElement, ToggleGroupRootProps>(function ToggleGroupRoot(t0, ref) {
  const $ = _c(9);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== className || $[6] !== otherProps || $[7] !== ref) {
    t1 = children ? <SubframeCore.ToggleGroup.Root asChild={true} {...otherProps}><div className={SubframeUtils.twClassNames("flex items-center gap-0.5 overflow-hidden rounded-md bg-neutral-100 px-0.5 py-0.5", className)} ref={ref}>{children}</div></SubframeCore.ToggleGroup.Root> : null;
    $[4] = children;
    $[5] = className;
    $[6] = otherProps;
    $[7] = ref;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
});
export const ToggleGroup = Object.assign(ToggleGroupRoot, {
  Item
});